'use strict';

const TOGGLE_BTN_SELECTOR = '[data-toggle]';

export function init() {
    document.addEventListener('click', event => {
        const element = event.target.closest(TOGGLE_BTN_SELECTOR);

        if (!element) {
            return;
        }

        const targetElement = document.querySelector(element.dataset.toggle);
        if (!targetElement) {
            return;
        }

        const bodyClass = element.dataset.toggleBodyClass;
        const toggleClass = element.dataset.toggleClass || 'is-toggled';

        const labelElement = document.querySelector(
            element.dataset.toggleLabelSelector || '.js-toggle__label'
        );

        const focusElement = document.querySelector(element.dataset.toggleFocus);

        const toggleLabel = element.dataset.toggleLabel;
        const isToggled = element.classList.contains(toggleClass);

        const closeElement = document.querySelector(element.dataset.toggleClose);

        if (closeElement && closeElement.classList.contains(toggleClass)) {
            closeElement.click();
        }

        targetElement.classList.toggle(toggleClass);
        element.classList.toggle(toggleClass);

        element.setAttribute('aria-expanded', isToggled ? 'false' : 'true');
        targetElement.setAttribute('aria-hidden', isToggled ? 'true' : 'false');

        if (toggleLabel && labelElement) {
            element.dataset.toggleLabel = element.innerHTML;
            labelElement.innerHTML = toggleLabel;
        }

        if (bodyClass) {
            document.body.classList.toggle(bodyClass);
        }

        if (!isToggled && focusElement) {
            focusElement.focus();
        }
    }, false)
}

export default { init }
